import styled from 'styled-components';

export const StyledTermsWrapper = styled.div`
    .top_level {
        counter-reset: list1;
        padding-inline-start: 0;

        li {
            display: block;
            &::before {
                counter-increment: list1;
                content: counter(list1) "."; 
                font-weight: 600;
                margin-left: 10px;
            }

            .second_level {
                counter-reset: list2;
                li {
                    &::before {
                        counter-increment: list2; 
                        content: counter(list1) "." counter(list2) "."; 
                    }

                    .third_level {
                        counter-reset: list3;
                        li {
                            &::before {
                                counter-increment: list3; 
                                content: counter(list1) "." counter(list2) "." counter(list3) "."; 
                            }
                        }
                    }
                }
            }
        }
    
        .paragraph {
            margin-right: 40px;
        }
    }
`